import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFMicrowave from '@/components/UI/svg/mm100/Icon/EFMicrowave';
import EFWaterHeater from '@/components/UI/svg/mm100/Icon/EFWaterHeater';
import EFLaptop from '@/components/UI/svg/mm100/Icon/EFLaptop';
import EFInductionCooker from '@/components/UI/svg/mm100/Icon/EFInductionCooker';
import EFLight from '@/components/UI/svg/mm100/Icon/EFLight';
import EFCrockpot from '@/components/UI/svg/mm100/Icon/EFCrockpot';
import EFAirConditioner from '@/components/UI/svg/mm100/Icon/EFAirConditioner';
import EFTV from '@/components/UI/svg/mm100/Icon/EFTV';
import EFFridge from '@/components/UI/svg/mm100/Icon/EFFridge';
import EFCustom from '@/components/UI/svg/mm100/Icon/EFCustom';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({}: any) {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const router = useRouter();
    const { locale } = router;

    const list2 = [
        {
            title: t('presale.product.kitD_Microwave'),
            icon: <EFMicrowave />,
        },
        {
            title: t('presale.product.kitD_WaterHeater'),
            icon: <EFWaterHeater />,
        },
        {
            title: t('presale.product.kitD_Laptop'),
            icon: <EFLaptop />,
        },
        {
            title: t('presale.product.kitD_InductionCooker'),
            icon: <EFInductionCooker />,
        },
        {
            title: t('presale.product.kitD_Light'),
            icon: <EFLight />,
        },
        {
            title: t('presale.product.kitD_Crockpot'),
            icon: <EFCrockpot />,
        },
        {
            title: t('presale.product.kitD_AirConditioner'),
            icon: <EFAirConditioner />,
        },
        {
            title: t('presale.product.kitD_TV'),
            icon: <EFTV />,
        },
        {
            title: t('presale.product.kitD_Fridge'),
            icon: <EFFridge />,
        },
        {
            title: t('presale.product.kitD_Custom'),
            icon: <EFCustom />,
        },
    ];

    return (
        <div className={`${css.kitD} kitD`}>
            <div className="kit-inter">
                <div className="kit-ms1">{t('presale.product.kitD_ms1')}</div>
                <div className="kit-ms2" style={{ display: locale === 'us' ? 'block' : 'none' }}>
                    <Link href={`/${locale}/calculators/power-kits`} newWin>
                        <span className="kit-ms2__Link">
                            {t('presale.product.kitD_link1')} {'>'}
                        </span>
                    </Link>
                </div>
                <div className="kit-box1">
                    <div className="kit-l">
                        <div className="kitd1-img">
                            <EFPic name={['kitD1.webp', 'kitD1.png']} className="fullImgs" alt="" />
                            <div className="line-box">
                                <div className="title product-2kWh">{t('presale.product.2kWh')}</div>
                                <div className="title product-4kWh">{t('presale.product.4kWh')}</div>
                                <div className="title product-5kWh">{t('presale.product.5kWh')}</div>
                                <div className="title product-10kWh">{t('presale.product.10kWh')}</div>
                                <div className="title product-15kWh">{t('presale.product.15kWh')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kit-box2">
                    <div className="kit-ms-a1">{t('presale.product.kitD_ms_a1')}</div>
                    <div className="kit-ms-a2">{t('presale.product.kitD_ms_a2')}</div>
                    <div className="list-box2">
                        {list2?.map((item: any, index: number) => (
                            <div className="icon-item" key={index}>
                                <div className="icon-box">{item.icon}</div>
                                <div className="icon-ms">{item.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
